import { findObjectUseCase } from "../../../usecases/object";

/**
 * Fetch all employment_type_assignment records for an employee (created <= endOfMonthIso),
 * sorted by created desc. Same concept as schedule_template_assignment: for each log day D,
 * pick the assignment where created <= D.
 */
export async function getEmploymentTypeAssignmentsForMonth(
  employeeId,
  endOfMonthIso,
) {
  if (!employeeId) return [];

  try {
    const results = await findObjectUseCase().execute(
      "employment_type_assignment",
      {
        where: {
          employeeId,
          // ...(endOfMonthIso && { created: { $lte: endOfMonthIso } }),
        },
        keys: ["employeeId", "name", "created"],
        sort: { created: -1 },
        limit: 5,
      },
    );
    return Array.isArray(results) ? results : [];
  } catch (e) {
    console.error("Error fetching employment_type_assignment:", e);
    return [];
  }
}

/**
 * Fetch all twenty_fourSeven_assignment records for an employee (created <= endOfMonthIso),
 * sorted by created desc. Same concept as schedule_template_assignment.
 */
export async function getTwentyFourSevenAssignmentsForMonth(
  employeeId,
  endOfMonthIso,
) {
  if (!employeeId) return [];
  // console.log("endOfMonthIso: ", endOfMonthIso);

  try {
    const results = await findObjectUseCase().execute(
      "twenty_fourSeven_assignment",
      {
        where: {
          employeeId,
          // ...(endOfMonthIso && { created: { $lte: endOfMonthIso } }),
        },
        keys: ["employeeId", "name", "created"],
        sort: { created: -1 },
        limit: 5,
      },
    );
    return Array.isArray(results) ? results : [];
  } catch (e) {
    console.error("Error fetching twenty_fourSeven_assignment:", e);
    return [];
  }
}

const toDateKey = (v) =>
  v == null ? null : new Date(v).toISOString().split("T")[0];

/**
 * Get the effective employment type name for a specific day D from assignment history.
 * Picks the most recent assignment where created <= dayKey (same as schedule_template_assignment).
 */
export function getEffectiveEmploymentTypeForDay(assignments, dayKey) {
  if (!Array.isArray(assignments) || !dayKey) return null;
  const a = assignments.find(
    (x) => x?.created && toDateKey(x.created) <= dayKey,
  );
  return a?.name ?? null;
}

/**
 * Get the effective twenty_fourSeven value for a specific day D from assignment history.
 */
export function getEffectiveTwentyFourSevenForDay(assignments, dayKey) {
  if (!Array.isArray(assignments) || !dayKey) return null;
  const a = assignments.find(
    (x) => x?.created && toDateKey(x.created) <= dayKey,
  );
  return a?.name ?? null;
}
